import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUpDown12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCaretUpDown12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.181 7.864a.5.5 0 1 0-.707-.707L6 9.632 3.525 7.158a.5.5 0 0 0-.707.707l2.828 2.827.353.354.354-.354zM2.818 4.148a.5.5 0 0 0 .708.707L6 2.38l2.474 2.474a.5.5 0 0 0 .707-.707L6.354 1.319 6 .966l-.353.353z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUpDown12);
